import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';
export default (function (params) {
  let apiUrl = `/api/ipqc/inspection/main?page_no=0&page_size=0`;
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '',
    name: 'IPQC_PROCESS_INSPECTION_GTE',
    method: 'GET'
  });
  useEffect(() => {
    if (params) {
      Object.keys(params).forEach(key => {
        if (key !== "page_no" && key !== "page_size") {
          // eslint-disable-next-line react-hooks/exhaustive-deps
          apiUrl += `&${key}=${params[key]}`;
        }
      });
      exec(apiUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [data || [], isLoading, exec, isRequestSuccessed];
})